<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>पे जी का परिचय: </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="5">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/7V_om-dK_mU"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="6">

                    <label for="" class="spn mt-2">पे जी एक भारतीय वित्तीय प्रौद्योगिकी
                        कंपनी है जो सभी प्रकार के व्यवसायों के लिए ऑनलाइन भुगतान समाधान प्रदान करती
                        है। 2018 में स्थापित, पे जी का लक्ष्य भारत में सभी प्रकार के व्यवसायों के लिए
                        ऑनलाइन भुगतान स्वीकार करने की प्रक्रिया को सरल बनाना और लेनदेन को आसान बनाना
                        है। पे जी व्यवसायों के साथ उनकी विशिष्ट आवश्यकताओं के अनुरूप अनुकूलित भुगतान
                        समाधान प्रदान करने के लिए काम करता है। यह लचीलापन व्यवसायों को अपने ग्राहकों
                        के लिए भुगतान अनुभव को बेहतर बनाने की अनुमति देता है।</label>

                    <label for="" class="spn mt-1">पे जी ने अपने उपयोगकर्ता-अनुकूल
                        इंटरफेस, प्रतिस्पर्धी मूल्य निर्धारण और व्यवसायों और ग्राहकों को समान रूप से
                        प्रदान की जाने वाली सुविधा के कारण भारतीय बाजार में लोकप्रियता हासिल की है।
                        यह भारत में विश्वसनीय और कुशल भुगतान प्रसंस्करण समाधान तलाश रहे स्टार्टअप,
                        छोटे व्यवसायों और बड़े उद्यमों के लिए एक पसंदीदा भुगतान गेटवे बन गया है।</label>
                    <label for="" class="spn mt-2">पे जी ने भारत में डिजिटल भुगतान को
                        अपनाने में महत्वपूर्ण भूमिका निभाई है। इसने व्यवसायों को अपने भुगतानों को
                        प्रभावी ढंग से प्रबंधित करने के लिए एक सुरक्षित, विश्वसनीय और
                        उपयोगकर्ता-अनुकूल मंच प्रदान करके ई-कॉमर्स और ऑनलाइन लेनदेन के विकास में
                        योगदान दिया है।</label>
                    <label for="" class="spn mt-2">पे जी एक भारतीय-आधारित ऑनलाइन पेमेंट
                        गेटवे है। यह एक ऐसा मंच प्रदान करता है जो व्यापारियों को सुरक्षित ऑनलाइन
                        भुगतान करने और बिलों का भुगतान आसानी से करने में सक्षम बनाता है। </label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="7">

                    <ul class="mt-3">
                        <li class="mt-2">
                            यह एक मजबूत पेमेंट गेटवे प्रदान करता है जो व्यवसायों को क्रेडिट और डेबिट
                            कार्ड, नेट बैंकिंग, यूपीआई, डिजिटल वॉलेट और अन्य सहित विभिन्न तरीकों से
                            ऑनलाइन भुगतान स्वीकार करने की अनुमति देता है।
                        </li>
                        <li class="mt-2">
                            पे जी सदस्यता-आधारित बिलिंग मॉडल का भी समर्थन करता है, जिससे व्यवसायों को
                            उन सेवाओं और उत्पादों के लिए आवर्ती भुगतान स्थापित करने की अनुमति मिलती
                            है जिनके लिए आवधिक भुगतान की आवश्यकता होती है।
                        </li>
                        <li class="mt-2">
                            प्लेटफ़ॉर्म चालान बनाने और प्रबंधित करने के लिए टूल भी प्रदान करता है,
                            जिससे व्यवसायों के लिए बिलिंग को संभालना और भुगतान स्थिति को ट्रैक करना
                            आसान हो जाता है।
                        </li>
                        <li class="mt-2">
                            पे जी सुरक्षा और अनुपालन को प्राथमिकता देता है। यह भुगतान कार्ड उद्योग
                            डेटा सुरक्षा मानक (PCI DSS ) स्तर 1 के अनुरूप है और संवेदनशील डेटा की
                            सुरक्षा के लिए एन्क्रिप्शन और अन्य सुरक्षा उपायों का उपयोग करता है।
                        </li>
                        <li class="mt-2">
                            प्लेटफ़ॉर्म वास्तविक समय विश्लेषण और अंतर्दृष्टि प्रदान करता है,
                            व्यवसायों को लेनदेन, ग्राहक व्यवहार और अन्य प्रदर्शन मेट्रिक्स पर
                            मूल्यवान डेटा प्रदान करता है।
                        </li>
                        <li class="mt-2">
                            पे जी ऑनलाइन लेनदेन की सुरक्षा को प्राथमिकता देता है और भुगतान प्रसंस्करण
                            के दौरान ग्राहक डेटा की सुरक्षा के लिए एन्क्रिप्शन और सुरक्षित सॉकेट
                            लेयर (SSL) तकनीक जैसे विभिन्न सुरक्षा उपायों को नियोजित करता है।
                        </li>
                        <li class="mt-2">
                            पे जी भुगतान या बिल भुगतान से संबंधित किसी भी प्रश्न या समस्या के समाधान
                            के लिए ग्राहक सहायता प्रदान करता है, जिससे एक सहज उपयोगकर्ता अनुभव
                            सुनिश्चित होता है।
                        </li>
                    </ul>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" id="8"
                    (mouseout)="showpayment(false,'4')">
                    <label for="" class="mt-3">पे जी, एक प्रमुख पेमेंट गेटवे कंपनी के
                        रूप में, भारत की डिजिटल अर्थव्यवस्था की वृद्धि और विकास में योगदान देने में
                        महत्वपूर्ण भूमिका निभाती है। यहां कुछ तरीके दिए गए हैं जिनसे पे जी भारत की
                        मदद कर रहा है:</label>

                    <label for="" class="mt-4"><b>वित्तीय समावेशन: </b>&nbsp; पे जी
                        डिजिटल लेनदेन में भाग लेने के लिए दूरस्थ या कम सेवा वाले क्षेत्रों सहित
                        व्यवसायों के लिए एक मंच प्रदान करके वित्तीय समावेशन की सुविधा प्रदान करता
                        है। यह वित्तीय सेवाओं तक पहुंच को व्यापक बनाता है और आर्थिक समावेशिता को
                        बढ़ावा देता है।</label>
                    <label for="" class="mt-4"><b>छोटे और मध्यम उद्यमों (SMEs) का
                            समर्थन करना: </b>&nbsp; पे जी डिजिटल भुगतान स्वीकार करने के लिए एक
                        सुरक्षित और कुशल साधन प्रदान करके छोटे और मध्यम उद्यमों को सशक्त बनाता है।
                        इससे न केवल इन व्यवसायों की विश्वसनीयता बढ़ती है बल्कि डिजिटल बाज़ार में</label>
                    <label for="" class="mt-4"><b>ई-कॉमर्स ग्रोथ: </b>&nbsp;ई-कॉमर्स
                        प्लेटफॉर्म में पे जी का निर्बाध एकीकरण भारत में संपन्न ऑनलाइन बाज़ार का
                        समर्थन करता है। एक विश्वसनीय और सुरक्षित भुगतान गेटवे प्रदान करके, पे जी
                        व्यवसायों के लिए आसान लेनदेन की सुविधा प्रदान करता है और उपभोक्ताओं के लिए</label>
                    <label for="" class="mt-4"><b>उपयोगकर्ता अनुभव को बढ़ाना:
                        </b>&nbsp;पे जी एक उपयोगकर्ता-अनुकूल इंटरफ़ेस और एक सुरक्षित भुगतान वातावरण
                        प्रदान करने पर केंद्रित है। सकारात्मक उपयोगकर्ता अनुभव के प्रति यह
                        प्रतिबद्धता डिजिटल लेनदेन में विश्वास बनाने में योगदान देती है और अधिक
                        व्यक्तियों को कैशलेस भुगतान विधियों को अपनाने के लिए प्रोत्साहित करती है।</label>
                        <label for="" class="mt-4"><b>डिजिटल इंडिया पहल: </b>&nbsp; पे जी
                            डिजिटल भुगतान विधियों के उपयोग को बढ़ावा देकर डिजिटल इंडिया पहल के साथ
                            जुड़ता है। यह नकद लेनदेन पर निर्भरता को कम करते हुए, डिजिटल रूप से सशक्त
                            समाज और अर्थव्यवस्था के सरकार के दृष्टिकोण का समर्थन करता है।</label>

                            <label for="" class="mt-4"><b>धोखाधड़ी की रोकथाम और
                                    सुरक्षा:</b>&nbsp; पे जी उपयोगकर्ताओं को धोखाधड़ी वाली गतिविधियों
                                से
                                बचाने के लिए उन्नत सुरक्षा उपाय अपनाता है। डिजिटल लेनदेन की अखंडता
                                सुनिश्चित
                                करके, पे जी एक सुरक्षित वित्तीय पारिस्थितिकी तंत्र के निर्माण में
                                योगदान देता</label>
                                <label for="" class="mt-4"><b>शैक्षिक और स्वास्थ्य देखभाल
                                        लेनदेन:</b>&nbsp;
                                        पे जी शिक्षा और स्वास्थ्य सेवा क्षेत्रों में ऑनलाइन भुगतान का
                                    समर्थन करता है,
                                    जिससे व्यक्तियों के लिए ट्यूशन फीस, चिकित्सा बिल और अन्य संबंधित
                                    खर्चों का
                                    भुगतान करना आसान हो जाता है। यह आवश्यक सेवाओं की पहुंच और दक्षता
                                    में योगदान</label>
                                    <label for="" class="mt-4"> <b>सरकारी सेवाएँ:</b>&nbsp; पे जी की
                                        भूमिका कर भुगतान और अन्य आधिकारिक लेनदेन सहित सरकारी सेवाओं
                                        के लिए डिजिटल
                                        लेनदेन का समर्थन करने तक फैली हुई है। यह अधिक कुशल और
                                        पारदर्शी शासन प्रणाली</label>
                                        <label for="" class="mt-4">भारतीय बाजार में पे जी की उपस्थिति
                                            विभिन्न क्षेत्रों पर सकारात्मक प्रभाव डालती है।
                                            सुरक्षित, कुशल और उपयोगकर्ता
                                            के अनुकूल भुगतान समाधान प्रदान करने की कंपनी की
                                            प्रतिबद्धता भारत में चल रहे
                                            डिजिटल परिवर्तन में योगदान करती है।

                                        </label>
                </div>
            </div>

        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    
                        <h5>
                            विषयसूची:
                        </h5>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro" alt=""> 
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover" [ngClass]="{'video':colors=='1'}"
                                    (click)="color('1')" >
                                    पे जी का परिचय</span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#6">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')" >

                                    पे जी का परिचय  </span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#7">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')" >  प्रमुख विशेषताऐं
                                </span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#8">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')" >
                                    पे जी भारत की कैसे मदद कर रहा है? </span>
                           
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Hindi PayG Overview.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    पे जी  </span>
                               
                                </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Hindi PayG Overview.pdf" download><img src="./assets/Downloadss.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
       
                <a [routerLink]="['/payment-gateway-working']">   <button class="btn  btn-color" (click)="menues('Payment Gateway Working')" >
                    <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पेमेंट गेटवे उद्योग की कार्यप्रणाली

                </button></a>
            </div>
            <div class="col-md-4    ">
              
                <a [routerLink]="['/e-agrement']">   <button class="btn btn-color" (click)="menues('E-Agreement')"
                    >ई-एग्रीमेंट
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>